/**
 * PDP — accordion exclusivo (sanfona): ao abrir um item, fecha os demais.
 */
(function () {
  function initExclusiveAccordions(root) {
    root.querySelectorAll('[data-accordion-exclusive]').forEach(function (accordion) {
      if (accordion.dataset.accordionExclusiveInit === 'true') return;
      accordion.dataset.accordionExclusiveInit = 'true';

      accordion.addEventListener(
        'toggle',
        function (event) {
          var target = event.target;
          if (!(target instanceof HTMLDetailsElement)) return;
          if (!target.open) return;

          accordion.querySelectorAll('details[open]').forEach(function (details) {
            if (details !== target) details.open = false;
          });
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initExclusiveAccordions(document);
    });
  } else {
    initExclusiveAccordions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initExclusiveAccordions(event.target);
  });
})();
